import { Record, List, Map } from "immutable";
import type { RecordOf, List as ListType, Map as MapType } from "immutable";
import {
  SET_DICTIONARY,
} from "../../helpers/constants";
import type {
  Actions,
  SetDictionary,
} from "../../actions/dictionaries";

export type Dictionaries =
  | "vertical"
  | "niche"
  | "platform"
  | "productCompany"
  | "department"
  | "country"
  | "ageGroup"
  | "departmentsByMarketingCompany"
  | "brand";

export type DropDownObjItemType = {
  label: string;
  value: string;
};

export type DropDownObjType = {
  [key in Dictionaries]?: DropDownObjItemType[];
};

export type DropDownType = MapType<Dictionaries, ListType<MapType<string, string>>>;

export type DefaultStateType = {
  dropdownLists: DropDownType;
};

const defaultState: DefaultStateType = {
  dropdownLists: Map() as DropDownType,
};

export const makeState = Record(defaultState);

export type State = RecordOf<DefaultStateType>;

export const initialState: State = makeState({});

export function initState(init: DropDownObjType = {}): State {
  const initImmutable: DropDownType = (Object.keys(init) as Dictionaries[]).reduce(
    (acc: DropDownType, key: Dictionaries): DropDownType => {
      const listItems = init[key]?.map((item: DropDownObjItemType) =>
        Map(item)
      ) ?? [];

      return acc.set(key, List(listItems));
    },
    Map() as DropDownType
  );

  return initialState.set("dropdownLists", initImmutable);
}

// eslint-disable-next-line default-param-last
export default (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_DICTIONARY: {
      const { payload }: SetDictionary = action;

      return state.withMutations((newState: State) => {
        (Object.keys(payload) as Dictionaries[]).forEach((key: Dictionaries) => {
          const items = payload[key] ?? [];
          const dictionaryItemsList: ListType<MapType<string, string>> = List(
            items.map((payloadItem: DropDownObjItemType) =>
              Map(payloadItem)
            )
          );

          newState.setIn(["dropdownLists", key], dictionaryItemsList);
        });
      });
    }
    default:
      return state;
  }
};